import { show } from "@intercom/messenger-js-sdk";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import type { SvgIconTypeMap } from "@mui/material";
import type { OverridableComponent } from "@mui/types";
import type { FunctionComponent } from "react";

import { XIcon } from "~/components/icons";
import { TikTokIcon } from "~/components/icons/TikTokIcon";
import { ROUTES } from "~/constants/routing";
import { SOCIAL_PROFILE_URLS } from "~/constants/socialUrls";

export interface SocialLink {
  Icon:
    | (OverridableComponent<SvgIconTypeMap> & { muiName: string })
    | FunctionComponent;
  to: string;
}

export interface SiteLink {
  label: string;
  to?: string;
  action?: () => void;
  target?: "_blank";
}

export const HELP_CENTER_LINK = "https://help.predictionhero.com";
export const METHODOLOGY_LINK = "/methodology";
export const PLATFORM_TOUR_LINK = "/tour";
export const LIFETIME_PREMIUM_LINK = "/lifetime-premium";

export const SOCIAL_LINKS: SocialLink[] = [
  {
    Icon: XIcon,
    to: SOCIAL_PROFILE_URLS.x,
  },
  {
    Icon: LinkedInIcon,
    to: SOCIAL_PROFILE_URLS.linkedin,
  },
  {
    Icon: InstagramIcon,
    to: SOCIAL_PROFILE_URLS.instagram,
  },
  {
    Icon: TikTokIcon,
    to: SOCIAL_PROFILE_URLS.tiktok,
  },
  {
    Icon: FacebookRoundedIcon,
    to: SOCIAL_PROFILE_URLS.facebook,
  },
];

export const SITE_LINKS: SiteLink[] = [
  {
    label: "Brand Kit",
    to: "https://brandfetch.com/predictionhero.com",
    target: "_blank",
  },
  {
    label: "API & Data Licensing",
    to: ROUTES.data.createURL(),
  },
  {
    label: "Help Center",
    to: HELP_CENTER_LINK,
    target: "_blank",
  },
  {
    label: "Disclaimer",
    to: ROUTES.disclaimer.createURL(),
  },
  {
    label: "Terms of Use",
    to: ROUTES.termsOfUse.createURL(),
  },
  {
    label: "Privacy Policy",
    to: ROUTES.privacyPolicy.createURL(),
  },
  {
    label: "Contact",
    action: show,
  },
  // {
  //   label: "How it works",
  //   to: ROUTES.howItWorks.createURL(),
  // },
];
